import createOrUpdateHiddenField from './createOrUpdateHiddenField';

const injectAudiShiftSource = (form, eventData) => {
	if (!form.querySelector('input[data-id="audiShiftSource"]')) {
		const prefix = window?.DDC?.getSiteProperty('Tier2Region')
			? 'DDC Area Site - '
			: 'DDC Dealer Site - ';
		let suffix = form?.dataset?.shiftSource || '';
		let value = prefix + suffix;

		if (!suffix) {
			const audiMap = new Map([
				['SPECIALS_LISTING_PARTS', 'DDC Specials Parts Page'],
				['PROMOTIONS_LISTING_PARTS', 'DDC Specials Parts Page'],
				['SPECIALS_LISTING_SERVICE', 'DDC Specials Service Page'],
				['PROMOTIONS_LISTING_SERVICE', 'DDC Specials Service Page'],
				['SPECIALS_LISTING_NEW', 'DDC Specials Sales Pages'],
				['SPECIALS_LISTING_USED', 'DDC Specials Sales Pages'],
				['PROMOTIONS_LISTING_NEW', 'DDC Specials Sales Pages'],
				['PROMOTIONS_LISTING_USED', 'DDC Specials Sales Pages'],
				['CONTACT', 'DDC Contact'],
				['CONTACT_INFORMATION', 'DDC Contact'],
				['EPRICE', 'DDC Get ePrice'],
				['PARTS_ORDER', 'DDC Parts Request'],
				['INFO_REQUEST', 'DDC Request More Info'],
				['REWARDS_MORE_INFO_FORM', 'DDC Request More Info'],
				['SHOWROOM', 'DDC Showroom'],
				['SERVICE_APPT', 'DDC Schedule Service'],
				['SPECIALS_INFO_REQUEST', 'DDC Specials'],
				['MENU_DRIVER', 'DDC Menu Driver'],
				['TRADE_IN', 'DDC Trade In'],
				['CONTACT_ON_DEPOSIT', 'DDC Reserve It Now'],
				['TEST_DRIVE', 'DDC Schedule Test Drive'],
				['MAKE_AN_OFFER', 'DDC Make an Offer'],
				['INSTANT_EPRICE', 'DDC Get Instant ePrice'],
				['INVENTORYFINDER', 'DDC Car Finder'],
				['GLOBAL_VEHICLE_INCENTIVE_LEAD', 'DDC Incentives'],
				['FINANCE', 'DDC Finance App'],
				['FINANCE_APPICATION_SHORT', 'DDC Finance App'],
				['FINANCEDRIVER', 'DDC Finance Driver']
			]);

			const pageAlias = window?.DDC?.dataLayer?.page?.pageInfo?.pageName;
			suffix = audiMap.get(eventData.trackingId);
			if (
				pageAlias === 'SPECIALS_LISTING_PARTS' ||
				pageAlias === 'SPECIALS_LISTING_SERVICE' ||
				pageAlias === 'SPECIALS_LISTING_NEW' ||
				pageAlias === 'SPECIALS_LISTING_USED' ||
				pageAlias === 'PROMOTIONS_LISTING_PARTS' ||
				pageAlias === 'PROMOTIONS_LISTING_SERVICE' ||
				pageAlias === 'PROMOTIONS_LISTING_NEW' ||
				pageAlias === 'PROMOTIONS_LISTING_USED'
			) {
				value = pageAlias;
			} else if (suffix) {
				value = prefix + suffix;
			} else {
				value = eventData.trackingId;
			}
		}

		createOrUpdateHiddenField(
			form,
			'_custom=SHIFT_SOURCE==audiShiftSource',
			value,
			{
				id: 'audiShiftSource',
				custom: 'true',
				'data-id': 'audiShiftSource'
			}
		);
	}
};

export default injectAudiShiftSource;
